export class DhaResponse {
  id: string;
  idNumber: string;
  payload: string;
  created: Date;
}

// What the details card shows for one ID number, while and after the lookup runs.
export class DhaLookup {
  idNumber: string;
  loading: boolean;
  person: DhaPerson;
  message: string;
}

// The DHA payload is XML, this is the PERSON element of it unpacked for display.
export class DhaPerson {
  error: string;
  idNumber: string;
  newIdNumber: string;
  surname: string;
  names: string;
  maidenName: string;
  deathStatus: string;
  birthPlace: string;
  dateOfBirth: string;
  dateOfDeath: string;
  deathPlace: string;
  marriageStatus: string;
  marriageDate: string;
  marriagePlace: string;
  spouseIdNumber: string;
  motherIdNumber: string;
  fatherIdNumber: string;
  children: Array<string> = new Array<string>();
}
